import { Grid } from '@mui/material';
import { Autocomplete } from '../../../../../ui/components/pure/autocomplete/autocomplete.component';
import { TextField } from '../../../../../ui/components/pure/text-field/text-field.component';
import { CourierFormModal } from '../../../components/courier-form-modal.component';
import { fullWidthStyle, rowGroupStyle } from '../../../components/courier-form.styles';
import { MoveCourierActionProps, useMoveCourierAction } from './move-courier-action.hook';

/** Moves a courier to another carrier group — none of the courier's own fields are in play. */
export function MoveCourierModal(props: MoveCourierActionProps) {
  const { state, handlers, control, handleSubmit, formConfig, unitMenuItems, currentUnitLabel, loading } =
    useMoveCourierAction(props);

  return (
    <CourierFormModal
      title={`Move ${props.courier.displayName || 'courier'}`}
      loading={loading}
      saving={state.saving}
      error={state.error}
      submitLabel="Move"
      onCancel={handlers.onCancel}
      onSubmit={handleSubmit(handlers.onSubmit)}
    >
      <Grid
        container
        spacing={2}
        style={rowGroupStyle}
        sx={{
          alignItems: 'flex-end'
        }}
      >
        <Grid size={6}>
          {/* Shown, not chosen: the destination expresses the whole move. */}
          <TextField
            textFieldVariant="floating"
            placeholder="Current group"
            value={currentUnitLabel}
            disabled
            fullWidth
            style={fullWidthStyle}
          />
        </Grid>
        <Grid size={6}>
          {/* Type-ahead: a network-scoped operator can be offered dozens of units. */}
          <Autocomplete
            control={control}
            name={formConfig.groupID.name}
            required={formConfig.groupID.required}
            rules={{ validate: formConfig.groupID.validate }}
            label={formConfig.groupID.label}
            placeholder={formConfig.groupID.label}
            options={unitMenuItems}
            getOptionLabel={(option) => option.label}
            loading={loading}
            fullWidth
          />
        </Grid>
      </Grid>
    </CourierFormModal>
  );
}
